// Libs
import clsx from "clsx";

// Utils
import { useTranslation } from "src/design-system/core";
import {
    MARKETING_ACTIONS_CREATE_VIEW_TK,
    MARKETING_ACTIONS_TRANSLATION_NAMESPACE,
} from "src/views/marketing-actions/config";

// Types
import { MarketingActionVariantEnum } from "src/utils/variants";

// Components
import { Alert, AlertTitle } from "@mui/material";
import { Trans } from "react-i18next";
import { OfferCharacteristicSharedInputStyles } from "src/views/marketing-actions/components/form/OfferCharacteristicCard/OfferCharcteristicCard.styles";

export const CheeckyAlert = ({
    isScenario = false,
    variantList,
}: {
    isScenario?: boolean;
    variantList: MarketingActionVariantEnum[];
}) => {
    const { t, translateCommon } = useTranslation(
        `${MARKETING_ACTIONS_TRANSLATION_NAMESPACE}:${MARKETING_ACTIONS_CREATE_VIEW_TK}`
    );
    const classes = OfferCharacteristicSharedInputStyles();
    const isSmartScheduler = variantList.includes(MarketingActionVariantEnum.SmartScheduler);
    const cheeckyAlertClassName = clsx(classes.CheeckyAlert, {
        [classes.CheeckyAlertScenario]: isSmartScheduler,
    });

    let conceptTranslation = translateCommon("concepts.offer");
    if (isSmartScheduler) {
        conceptTranslation = translateCommon("concepts.smart-scheduler");
    }

    if (isScenario) {
        conceptTranslation = translateCommon("concepts.scenario");
    }

    return (
        <Alert severity="error" className={cheeckyAlertClassName}>
            {/* Title */}
            <AlertTitle>{t("cheecky-alert-title")}</AlertTitle>
            {/* Content */}
            <Trans
                i18nKey={`${MARKETING_ACTIONS_TRANSLATION_NAMESPACE}:${MARKETING_ACTIONS_CREATE_VIEW_TK}.cheecky-alert-content`}
                values={{
                    variant: conceptTranslation,
                }}
            />
        </Alert>
    );
};
